(function() {
    'use strict';

    angular
        .module('vhols')
        .directive("trackEvent", ["messageService", function(messageService) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    function onClick() {
                        messageService.message({ eventName: attrs.trackEvent, eventData: attrs.trackData || {} });
                    }

                    element.on(attrs.eventName || 'click touchend', onClick);
                    scope.$on('$destroy', function() {
                        element.off('click', onClick);
                    });
                }
            };
        }]);

})();
